const features = [
  {
    title: "Huge FPS boosts without lag",
    description:
      "We've been working our a**es off to make latency almost negligible. This means you don't need gigabit internet to have a good time.",
    imagePosition: "right",
    video: "./website-lag.mp4",
  },
  {
    title: "Play anything, anywhere, anytime",
    description:
      "Play 99% of games for as long as you want however you want. You can also mod any game without problems.",
    imagePosition: "left",
    video: "./game-outside.mp4",
  },
  {
    title: "Speed up your entire computer",
    description:
      "We're experimenting with speeding up your entire computer with remote hardware acceleration. Soon, you can expect speedups across the board.",
    imagePosition: "right",
    video: "./all-round-speedups.mp4",
  },
];

export default function Features() {
  return (
    <section
      className="py-12 px-4 xl:px-24 mx-auto max-w-[1600px] grid grid-cols-1 gap-y-20"
      id="features"
      data-aos="fade-in"
      data-aos-duration="1000"
    >
      <h2 className="text-[2.5rem] md:text-[4.5rem] max-w-5xl text-center mx-auto mb-16">
        We made a graphics card that you can download
      </h2>

      {features.map((f, i) => (
        <div
          key={i}
          className={`
            flex flex-col-reverse xl:flex-row items-center justify-between gap-8 lg:gap-12 w-full
            ${f.imagePosition === "left" ? "xl:flex-row-reverse" : ""}
          `}
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-delay={150 + i * 150}
        >
          {/* Text Block */}
          <div
            className={`
              flex flex-col items-center text-center xl:items-start xl:text-left
              xl:w-[55%]
            `}
          >
            <h3 className="text-white text-[2rem] md:text-6xl mb-4 md:mb-10">
              {f.title}
            </h3>
            <p className="text-white max-w-100 md:text-2xl leading-relaxed">
              {f.description}
            </p>
          </div>

          {/* Video Block */}
          <div className="xl:w-[45%] flex justify-center">
            <video
              className="bg-card min-h-[150px] w-full aspect-[16/9] shadow-lg object-cover"
              autoPlay
              muted
              loop
              playsInline
            >
              <source src={f.video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      ))}
    </section>
  );
}
